import Cookies from "universal-cookie";

export default function useJwt() {
  const cookies = new Cookies();
  const jwt = cookies.get("_GTM");

  if (process.env.REACT_APP_DEV === "true") return "jwt";

  return jwt;
}
